import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUserCircle } from "react-icons/fa";
import { getUserPreferences, getCurrentUserInfo, getLobbyDetailsFromInvite } from "./Api";

import { Spinner } from "react-bootstrap";

import InviteFriends from "./lobby/invite/InviteFriend";
import ActiveMatches from "./available_matches/ActiveMatches";
import MyLobbyInvites from "./lobby/invite/MyLobbyInvites";
import Preference from "./preference/Preference";

import { initiateMatchQueue_1v1, cancelMatchQueue_1v1, getMatchQueue_1v1, } from "./lobby/Api/Api_1v1"
import { getMatchInfo_2v2, startFindingMatch, fetchTeamQueueStarted, canceFindingMatch } from "./lobby/Api/Api_2v2";
import { getMatchInfo_3v3 } from "./lobby/Api/Api_3v3";
import { getMatchInfo_4v4 } from "./lobby/Api/Api_4v4";
import { getMatchInfo_5v5 } from "./lobby/Api/Api_5v5";

import { leaveInviteLobby } from "./lobby/invite/active_lobby/Api"


function MatchModal({ onClose }) {
  const [userPref, setUserPref] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [showPreference, setShowPreference] = useState(false);
  const [showActiveMatches, setShowActiveMatches] = useState(false);
  const [showLobbyInvites, setShowLobbyInvites] = useState(false);
  const [prefLoading, setPrefLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isStopping, setIsStopping] = useState(false);

  // 1v1 spinner
  const [searchingMatch, setSearchingMatch] = useState(false);




  // team searching
  const [searchingTeamMatch, setSearchingTeamMatch] = useState(false);
  const [searchingTeamMatchSpinner, setSearchingTeamMatchSpinner] = useState(false);



  // invite friend
  const [showInviteFriends, setShowInviteFriends] = useState(false);

  // lobby for the invited
  const [hasLobbyInvited, setHasLobbyInvited] = useState(false);
  const [hasLobbyInfo, sethasLobbyInfo] = useState(null);



  // match status

  const [hasTeamQueueStarted, sethasTeamQueueStarted] = useState(null);

  const fetchUserData = async () => {
    try {
      setPrefLoading(true); // start loading
      const pref = await getUserPreferences();



      setUserPref(pref);    // false if invalid
    } catch (e) {
      console.error("Failed to fetch preferences:", e.message || e);
      setUserPref(false);   // treat error as no preference
    } finally {
      setPrefLoading(false); // finished loading
    }

    // Fetch other data
    try {
      const user = await getCurrentUserInfo();
      setCurrentUser(user);

    } catch (e) {
      console.error("Failed to fetch user/lobby data:", e.message || e);
    }
  };

  const fetchLobbyInfo = async () => {

    const lobbyInviteInfos = await getLobbyDetailsFromInvite();

    sethasLobbyInfo(lobbyInviteInfos);


  };

  const fetchQueuingStatus = async () => {

    const queuStatus = await fetchTeamQueueStarted();

    sethasTeamQueueStarted(queuStatus);

  };

  useEffect(() => {
    fetchUserData();
    fetchLobbyInfo();
    fetchQueuingStatus();
  }, []);





  const renderBlock1 = () => {
    const profileImage = currentUser?.profile_image;
    const location = userPref?.location || "Unknown";
    const height = currentUser?.height || "-";
    const weight = currentUser?.weight || "-";

    return (
      <div className="px-3 position-relative" style={{ // color: "black" 


      }}>
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start mt-4 w-100">

          {/* Profile Column */}
          <div
            className="d-flex flex-column align-items-center w-100 order-1 order-lg-2 mb-3 mb-lg-0 ms-lg-4"
            style={{
              backgroundColor: "#c76824",
              borderRadius: "16px",
              padding: "20px",
              transition: "all 0.2s ease-in-out",
              minHeight: "300px",
              color:'white',
            }}
          >
            {showActiveMatches ? (
              <ActiveMatches onClose={async () => {
                setShowActiveMatches(false);
                await fetchUserData();
              }} />
            ) : showLobbyInvites ? (
              <MyLobbyInvites onClose={async () => {
                setShowLobbyInvites(false);
                await fetchUserData();

                setShowPreference(false);
                setSearchingMatch(false);
                setSearchingTeamMatch(false);
                setSearchingTeamMatchSpinner(false)

                fetchLobbyInfo();
                fetchQueuingStatus();
              }} />
            ) : showPreference ? (
              <Preference
                userPref={userPref}
                onBackWithSave={async (updatedPref) => {
                  await fetchUserData();
                  setShowPreference(false);
                  setSearchingMatch(false);
                  setSearchingTeamMatch(false);
                  setSearchingTeamMatchSpinner(false)
                  sethasTeamQueueStarted(false);
                }}
              />
            ) : showInviteFriends ? (
              <InviteFriends onClose={() => setShowInviteFriends(false)} />
            ) :
              searchingMatch ? (


                <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                  <div className="spinner-border" role="status" style={{ width: '80px', height: '80px',
                   //  color: '#000'
                     
                     }} />
                  <p className="mt-3" style={{ fontWeight: 600,
                    
                   // color: "#242121", 
                    
                    textAlign: "center" }}>
                    Please wait while we find your match.
                  </p>
                  <p className="mt-1" style={{ 
                   // color: "#242121",
                     textAlign: "center",
                     fontSize: "0.9rem" }}>
                    We will notify you when you get a match.
                  </p>
                  <button
                    className="btn btn-warning mt-3"
                    style={{ //color: "#000",
                       fontWeight: "700",
                        // border: "2px solid #ff9b54", 
                        borderRadius: "8px" }}
                    onClick={async () => {
                      try {
                        await cancelMatchQueue_1v1();
                        console.log("1v1 match queue canceled");
                      } catch (err) {
                        console.error("Failed to cancel 1v1 match queue:", err);
                      } finally {
                        setSearchingMatch(false);
                      }
                    }}
                  >
                    Stop Searching
                  </button>
                </div>


              ) : searchingTeamMatch ? (

                searchingTeamMatchSpinner ? (
                  // Render your spinner here

                  <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                    <div className="spinner-border" role="status" style={{ width: '80px', height: '80px', color: '#000' }} />
                    <p className="mt-3" style={{ fontWeight: 600,
                      // color: "#242121",
                        textAlign: "center" }}>
                      Please wait while we find your match.
                    </p>
                    <p className="mt-1" style={{
                       //color: "#242121",
                        textAlign: "center", fontSize: "0.9rem" }}>
                      We will notify you when you get a match.
                    </p>
                    <button
                      className="btn btn-warning mt-3"
                      style={{
                        // color: "#000",
                        fontWeight: "700",
                        // border: "2px solid #ff9b54",
                        borderRadius: "8px",
                      }}
                      disabled={isStopping} // disable while stopping
                      onClick={async () => {
                        setIsStopping(true); // start loading
                        try {
                          await canceFindingMatch(); // wait for async operation
                          setSearchingTeamMatchSpinner(false); // stop spinner after success
                          sethasTeamQueueStarted(false);

                        } catch (err) {
                          console.error("Error stopping team match search:", err);
                        } finally {
                          setIsStopping(false); // reset loading state
                        }
                      }}
                    >
                      {isStopping ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Stopping...
                        </>
                      ) : (
                        "Stop Searching"
                      )}
                    </button>
                  </div>
                ) : (

                  <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    style={{ minHeight: "200px" }}
                  >
                    <h2
                      className="text-center w-100 mb-3"
                      style={{
                        fontWeight: 600,
                      //  color: "#242121",
                        textTransform: "uppercase",
                        overflowWrap: "break-word",
                      }}
                    >
                      {userPref
                        ? `${userPref.game_type || "None"} | ${userPref.player || "None"} | ${userPref.sport_name || "None"
                        }`
                        : "None | None | None"}
                    </h2>
                    <p className="mt-3 text-center" style={{ fontWeight: 600, // color: "#242121" 

                    }}>
                      Please invite another player before starting.
                    </p>
                    <div className="d-flex gap-2">
                      <button className="btn btn-primary mt-3" onClick={() => setShowInviteFriends(true)}>
                        Invite Player
                      </button>
                      <button
                        className="btn btn-warning mt-3"
                        style={{ fontWeight: 700 }}
                        disabled={isLoading} // disable while waiting
                        onClick={async () => {
                          if (userPref.player === "2v2") {
                            setIsLoading(true); // start loading immediately
                            try {
                              const info = await getMatchInfo_2v2();
                              if (info.total_members < 2) {
                                alert(
                                  "Invite at least 1 player to start a 2v2 match. You can message them to let them know."
                                );
                              } else {
                                await startFindingMatch(); // wait for async operation
                                setSearchingTeamMatchSpinner(true); // show spinner only after operation completes


                              }


                            }


                            catch (err) {
                              alert("You need to invite at least 1 player to start a 2v2 match.");
                              console.error("Error starting 2v2 match:", err);
                            } finally {
                              setIsLoading(false); // reset loading state
                            }
                          } else if (userPref.player === "3v3") {
                            setIsLoading(true); // start loading immediately
                            try {
                              const info = await getMatchInfo_3v3();
                              if (info.total_members < 3) {
                                alert(
                                  "Invite at least 2 player to start a 3v3 match. You can message them to let them know."
                                );
                              } else {
                                await startFindingMatch(); // wait for async operation
                                setSearchingTeamMatchSpinner(true); // show spinner only after operation completes
                              }
                            } catch (err) {
                              alert("You need to invite at least 2 player to start a 3v3 match.");
                              console.error("Error starting 3v3 match:", err);
                            } finally {
                              setIsLoading(false); // reset loading state
                            }


                          } else if (userPref.player === "4v4") {
                            setIsLoading(true); // start loading immediately
                            try {
                              const info = await getMatchInfo_4v4();
                              if (info.total_members < 4) {
                                alert(
                                  "Invite at least 3 player to start a 4v4 match. You can message them to let them know."
                                );
                              } else {
                                await startFindingMatch(); // wait for async operation
                                setSearchingTeamMatchSpinner(true); // show spinner only after operation completes
                              }
                            } catch (err) {
                              alert("You need to invite at least 3 player to start a 4v4 match.");
                              console.error("Error starting 4v4 match:", err);
                            } finally {
                              setIsLoading(false); // reset loading state
                            }
                          } else if (userPref.player === "5v5") {

                            setIsLoading(true); // start loading immediately
                            try {
                              const info = await getMatchInfo_5v5();
                              if (info.total_members < 5) {
                                alert(
                                  "Invite at least 4 player to start a 5v5 match. You can message them to let them know."
                                );
                              } else {
                                await startFindingMatch(); // wait for async operation
                                setSearchingTeamMatchSpinner(true); // show spinner only after operation completes
                              }
                            } catch (err) {
                              alert("You need to invite at least 4 player to start a 5v5 match.");
                              console.error("Error starting 5v5 match:", err);
                            } finally {
                              setIsLoading(false); // reset loading state
                            }
                          }

                          fetchQueuingStatus();



                        }}
                      >
                        {isLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Waiting...
                          </>
                        ) : (
                          "Match"
                        )}
                      </button>
                    </div>
                  </div>
                )
              ) : hasLobbyInvited ? (

                <div className="text-center mt-3">
                  <p style={{ fontWeight: 600, color: "#242121" }}>
                    🎉 You’re currently hanging out in your friend’s lobby!
                    If you’d like to leave, you can do so anytime below.
                  </p>
                  <button
                    type="button"
                    className="btn btn-danger mt-2"
                    onClick={async () => {

                      if (window.confirm("⚠️ If you leave now, this is irreversible. Do you want to continue?")) {

                        try {
                          const permissionOk = await leaveInviteLobby(hasLobbyInfo.lobby_id);

                          if (permissionOk) {
                            setHasLobbyInvited(false);

                            fetchLobbyInfo();
                            fetchQueuingStatus();

                          } else {
                            alert("🚦 Hold on! You can’t leave the lobby just yet.\n\nYour friend’s lobby is currently in the match queue. Please ask them to stop searching before you can leave.");
                          }
                        } catch (err) {
                          console.error("Failed to leave lobby:", err);
                          alert("Something went wrong while leaving the lobby.");
                        }

                      }

                    }
                    }
                  >
                    Leave Lobby
                  </button>

                </div>





              ) : (
                <>
                  <h1>PROFILE</h1>
                  <h2 className="text-center w-100 mb-3" style={{ fontWeight: 600,
                    // color: "#242121", 
                     textTransform: "uppercase", overflowWrap: "break-word" }}>
                    {userPref
                      ? `${userPref.game_type || "None"} | ${userPref.player || "None"} | ${userPref.sport_name || "None"}`
                      : "None | None | None"}
                  </h2>

                  <div className="mb-3 d-flex justify-content-center align-items-center" style={{ width: "140px", height: "140px" }}>
                    {profileImage ? (
                      <img
                        src={`${profileImage}?t=${Date.now()}`}
                        alt="User profile"
                        style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", 
                          // border: "2px solid rgba(0,0,0,0.2)" 
                        }}
                        onError={(e) => e.currentTarget.src = "/images/avatar.png"}
                      />
                    ) : (
                      <FaUserCircle size={140} // color="#ced4da" 
                      
                      />
                    )}
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "4px", fontSize: 14, lineHeight: 1.1, letterSpacing: "-0.5px", maxWidth: "250px", textAlign: "center" }}>
                    <div>{location || "N/A"}</div>
                    <div>{height || "N/A"}</div>
                    <div>{weight || "N/A"}</div>
                  </div>
                </>
              )}
          </div>

          <div
            className="d-flex flex-row flex-lg-column gap-3 flex-wrap justify-content-center w-100 order-2 order-lg-1"
            style={{
              minWidth: "200px",
              maxWidth: "250px",
              padding: "20px",
              borderRadius: "12px",
               backgroundColor: "#c0601b",
               // border: "2px solid #ff9b54",
              transition: "all 0.2s ease-in-out",
              color: 'white',
            }}
          >
            {["Active Matches", "Lobby Invites", "Preference", "Match"].map((btn, idx) => {
              let isDisabled = prefLoading || (userPref === false && btn !== "Preference");


              if (btn === "Lobby Invites" && hasLobbyInfo?.is_leader === false) {
                isDisabled = true;
              }

              if (btn === "Lobby Invites" && hasTeamQueueStarted?.status === 200) {
                isDisabled = true;
              }
              return (
                <button
                  key={idx}
className="btn btn-lg w-100 text-white"
                  onClick={async () => {
                    setShowActiveMatches(btn === "Active Matches");
                    setShowLobbyInvites(btn === "Lobby Invites");
                    setShowPreference(btn === "Preference");

                    if (btn === "Match") {
                      setIsLoading(true); // start loading
                      try {
                        // prevent member (non-leader) from starting match
                        if (hasLobbyInfo?.is_leader === false) {
                          setHasLobbyInvited(true);
                          return;
                        }

                        if (userPref?.player === "1v1") {
                          setSearchingMatch(true);
                          try {
                            const queueResponse = await getMatchQueue_1v1();

                            if (queueResponse?.status === 200) {
                              console.log("User already in match queue, showing spinner.");
                            } else if (queueResponse?.status === 204) {
                              const payload = {
                                height: currentUser?.height || 0,
                                weight: currentUser?.weight || 0,
                                sport_id: userPref?.sport_id || 0,
                                location: userPref?.location || "",
                                latitude: userPref?.latitude || 0,
                                longitude: userPref?.longitude || 0,
                                maximum_distance: userPref?.maximum_distance || 0,
                                min_age: userPref?.min_age || 0,
                                max_age: userPref?.max_age || 0,
                                game_type: userPref?.game_type || "1v1",
                                player: "1v1",
                                gender_preference: userPref?.gender_preference || "any",
                              };

                              await initiateMatchQueue_1v1(payload);
                              console.log("1v1 match queue initiated", payload);
                            }
                          } catch (err) {
                            console.error("Error checking/initiating 1v1 queue:", err);
                            setSearchingMatch(false);
                          }
                        } else {
                          if (hasTeamQueueStarted?.status === 200) {
                            setSearchingTeamMatchSpinner(true);
                          }
                          setSearchingTeamMatch(true);
                        }
                      } catch (err) {
                        console.error("Error starting match:", err);
                      } finally {
                        setIsLoading(false); // end loading no matter what
                      }
                    }



                  }}
                  disabled={isDisabled || isLoading} // ⬅️ Disable button while loading
                  style={{
                   // backgroundColor: "#ff9b54",
                 //   color: "#000",
                    fontWeight: "700",
                  //  border: "2px solid #ff9b54",
                    borderRadius: "8px",
                  }}
                >
                  {btn === "Match" && isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </>
                  ) : (
                    btn
                  )}
                </button>


              );
            })}
          </div>

        </div >
      </div >
    );
  };






  const renderLobby = () => {
    if (showLobbyInvites)
      return (
        <MyLobbyInvites
          onClose={async () => {
            setShowLobbyInvites(false);
            await fetchUserData(); // refetch user state after closing invites
          }}
        />
      );





    if (showPreference) {
      return (
        <Preference
          onBackWithSave={async (updatedPref) => {
            await fetchUserData();
            setShowPreference(false);
            setSearchingMatch(false); // stop searching when Preference is closed

          }}
          userPref={userPref}
        />
      );
    }



    return renderBlock1();
  };

  return (
    <div className="modal fade show d-block" style={{ // backgroundColor: "rgba(0,0,0,0.5)" 

    }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "900px", width: "95%" }}>
        <div className="modal-content position-relative p-4" 
        style={{
          minHeight: "500px",
  backgroundColor: "rgb(70, 25, 5)",
         color: "#fff",
          borderRadius: "16px",
        }}>




          <button
            className="position-absolute top-0 end-0 m-2"
            onClick={onClose}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
            //  backgroundColor: "#fff",
            //  color: "#ff9b54",
              fontSize: "24px",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="bi bi-x-lg" style={{ pointerEvents: "none" }}></i>
          </button>


          {/* ONLY RENDER BLOCK1 NOW */}
          {renderBlock1()}
        </div>
      </div>
    </div>
  );

}

export default MatchModal;
